/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-02-24 19:05:11
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-05-27 17:43:13
 * @FilePath: /unifyxp-v2-store-portal/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups.tsx
 */
import Button from '@/src/components/Antd/Button/Button';
import { DeleteOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import React from 'react';
import css from './css.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Btns = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onSubmit,
    onCopy,
    onDelete,
    onSaveDisable,
    onDiscard,
    extraLeft,
    displayDuplicateGroup,
    extendButton, //拓展按钮
    extraMid,
    rarePart,
    saveText,
    disableDicard,
    disableDuplicate,
    disableDelete,
  } = props;

  return (
    <div className={css.topRight}>
      {onSubmit && !onSaveDisable && (
        <p>{getI18n('general.commonHeader.leave_header')}</p>
      )}
      {extraLeft}

      {onDiscard && (
        <Button
          className={css.button}
          disabled={!!disableDicard}
          onClick={() => {
            onDiscard();
          }}>
          {getI18n('general.commonHeader.discard_text')}
        </Button>
      )}

      {extendButton}
      {extraMid}
      {onSubmit && (
        <Button
          type='primary'
          className={css.saveBtn}
          onClick={() => {
            onSubmit();
          }}
          disabled={onSaveDisable}>
          {saveText || getI18n('general.save')}
        </Button>
      )}

      {displayDuplicateGroup && (
        <React.Fragment>
          {onCopy && (
            <Button
              icon={<UsergroupAddOutlined />}
              onClick={onCopy}
              className={css.button}
              disabled={!!disableDuplicate}>
              {getI18n('general.duplicate')}
            </Button>
          )}
          {onDelete && (
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={onDelete}
              className={css.deleteBtn}
              disabled={!!disableDelete}>
              {getI18n('general.delete')}
            </Button>
          )}
        </React.Fragment>
      )}
      {rarePart || null}
    </div>
  );
};
export default Btns;
